import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Trans, withTranslation } from '@mc/i18n'

import FacebookButton from '../FacebookButton'
import GoogleButton from '../GoogleButton'
import FormFields from './FormFields'

class RegisterForm extends PureComponent {
  static propTypes = {
    facebookSignUp: PropTypes.func.isRequired,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    t: PropTypes.func,
    userAgent: PropTypes.string,
  }

  static defaultProps = {
    title: 'Create Account',
  }

  render() {
    const { facebookSignUp, title, subtitle, t, userAgent } = this.props

    return (
      <div>
        <h4 className='mc-text-h4 mc-text--center mc-mb-6'>{title}</h4>
        {subtitle && (
          <p className='mc-text--center mc-mb-6 mc-opacity--muted'>
            {subtitle}
          </p>
        )}
        <div className='mc-mb-4'>
          <GoogleButton userAgent={userAgent}>
            {t('registerForm.google')}
          </GoogleButton>
        </div>

        <div className='mc-mb-4'>
          <FacebookButton onLogin={facebookSignUp} userAgent={userAgent}>
            {t('registerForm.facebook')}
          </FacebookButton>
        </div>

        <div className='mc-mb-4'>
          <p className='mc-text-hr mc-text-x-small mc-opacity--muted mc-text--uppercase mc-mt-3'>
            <Trans i18nKey='registerForm.or' ns='@mc/authentication'>
              <span></span>
            </Trans>
          </p>
        </div>

        <FormFields {...this.props} />
      </div>
    )
  }
}

export default withTranslation('@mc/authentication')(RegisterForm)
